<!-- 所有事务公用选择人员子组件
    1、定义三个全局变量
    2、在index获取数据
    3、选择人员更改全局变量值
-->

<template>
    <div style="display: inline-block" >
        <el-select
                ref="chooseKpi"
                @click.native="clickSelectPeople"
                v-model="peopleName_global"
                v-on:change="handleSelectInputClick"
                :disabled="jinyong"
                    placeholder="" style="width: 100%">
            <el-option v-for="(item,index) in options" :key="item.user_id"
                       :label="item.user_name"
                       :value="item.user_id">
            </el-option>
        </el-select>

        <el-dialog
                id="selectPeople_ID"
                :modal-append-to-body='false'
                title="请选择人员"
                :visible.sync="openModelSelect"
                :show-close="false"
                width="500px"
                @close="closeModel"
                >
            <div slot="title" class="header-title" style="text-align: center;height: 46px;position: relative">
                <el-button v-if="parent_globalIsNull()"
                        @click.native="clickBtnReturn" type="danger" size="small"
                           style="float: left;margin-top: 7px;position: absolute;left: 0">
                     返回
                </el-button>
                <span  class="title-name" style="color: #3998f7;line-height: 46px">请选择人员</span>
                <el-button @click.native="clickBtn" type="success" size="small"
                           style="float: right;margin-top: 7px;position: absolute;right: 0">确定
                </el-button>
            </div>
            <el-row>
                <el-col style="border: 1px solid transparent;padding:10px">
                    <div style="width: 100%;height: 50px;background: white;border-radius: 6px;">
                        <div style="float: left;overflow: hidden;width: 40px;height: 40px;border-radius: 50%;
                                    position: relative;margin-top:5px;margin-left: 10px">
                            <img :src="self.headSrc" alt="" width="40px" height="40px"
                                 style="float: left;position: absolute;
                                        top:50%;object-fit: cover;
                                        left:50%;
                                        transform: translate(-50%,-50%);">
                        </div>
                        <div style="float: left;margin-left: 10px">
                            <span style="line-height: 50px;font-size: 16px;color: #3998f7">本人&nbsp;
                                [{{self.name}}]</span>
                        </div>
                        <div style="float: right " >
                            <img :src="self.imgSrc"  @click="imgClick(self)"
                                 alt="" width="25" height="25" style="margin-top: 12px;
                            margin-right: 10px;cursor: pointer">
                        </div>
                    </div>
                </el-col>
                <el-col style="border: 1px solid transparent;padding: 0 10px;margin-top: 5px">
                    <el-row>
                        <el-col style="border: 1px solid transparent;width: 49%">
                            <div
                                    style="border-radius: 6px;width: 100%;height: 40px;background: white;
                                    padding: 10px 0px 10px 0px">
                                <div style="float: left;height: 100%">
                                    <p
                                            style="font-size: 16px;color: #3998f7;margin-top: 0px;margin-left: 5px;margin-bottom: 7px">直属团队</p>
                                    <span style="margin-left: 5px">选中所有直接下属</span>
                                </div>
                                <div style="float: right;height: 100%">
                                    <img :src="directly.imgSrc" alt="" width="25" height="25"
                                         @click="imgClick(directly)"
                                         style="margin-top: 5px;margin-right: 10px;cursor: pointer">
                                </div>
                            </div>
                        </el-col>
                        <el-col style="width: 2%;border: 1px solid transparent"></el-col>
                        <el-col style="border: 1px solid transparent;width: 49%">
                            <div
                                    style="border-radius: 6px;width: 100%;background: white;height: 40px;
                                    padding: 10px 0px 10px 0px">
                                <div style="float: left;height: 100%">
                                    <p
                                            style="font-size: 16px;color: #3998f7;margin-top: 0px;margin-left: 5px;margin-bottom: 7px">所有下属</p>
                                    <span style="margin-left: 5px">选中我所有的下属</span>
                                </div>
                                <div style="float: right;height: 100%">
                                    <img :src="allSubordinates.imgSrc" alt="" width="25" height="25"
                                         @click="imgClick(allSubordinates)"
                                         style="margin-top: 5px;margin-right: 10px;cursor: pointer">
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col style="margin-top: 10px;padding: 0 10px">
                    <span style="margin-left: 5px">或直接从辖区架构中选择人员</span>
                </el-col>
                <el-col style="margin-top: 10px">
                    <ul style="width: 100%;background: white">
                        <li v-for="(item,i) in ou_array" style="height: 50px;border-bottom: 1px solid #fafafa;cursor: pointer"
                            v-if="ou_array.length > 0">
                            <div style="width: 94%;display: inline-block" @click="ouClick(item)">
                                <span style="display: inline-block;margin-left: 20px;line-height: 50px;width: 88%">{{item.name}}</span>
                                <img :src="item.ouSrc" width="25" height="25" style="position: relative;top: 8px">
                            </div>
                            <img @click="getPeopleArray(item)" src="../../../../assets/images/next.png" width="12" height="20" style="position: relative;top: 6px">
                        </li>
                    </ul>
                </el-col>
                <el-col style="margin-top: 10px">
                    <ul style="width: 100%;background: white">
                        <li v-for="(item,i) in options" style="height: 50px;border-bottom: 1px solid #fafafa">
                            <div
                                    style="float: left;overflow: hidden;width: 40px;height: 40px;border-radius: 50%;
                                    position: relative;margin-top: 5px;margin-left: 20px">
                                <img :src="item.headSrc" alt="" width="40px" height="40px"
                                     style="float: left;position: absolute;
                                        top:50%;object-fit: cover;
                                        left:50%;
                                        transform: translate(-50%,-50%);">
                            </div>
                            <div style="float: left">
                                <p style="margin-top: 10px;margin-bottom: 0;margin-left: 10px;text-align: left">
                                    {{item.name}}
                                </p>
                                <p style="margin-top:4px ;margin-bottom: 0;margin-left: 10px">{{item.title}}</p>
                            </div>
                            <div style="float: right">
                                <img @click="imgClick(item)" :src="item.imgSrc" alt="" width="25" height="25"
                                     style="margin-top: 12px;
                            margin-right: 20px;cursor: pointer;">
                            </div>
                        </li>
                    </ul>
                </el-col>
                <el-col v-if="ou_array.length==0&&options.length==0" style="text-align:center;padding-bottom: 30px">
                    <img src="../../../../assets/images/691C8AAA4F3F3242DF42BB05FCAFB165.png" width="200" height="200">
                </el-col>
            </el-row>
        </el-dialog>
    </div>

</template>

<script>
    import http from '../../../../APIService/http'
    import suc_png from '../../../../assets/images/input_selectSuccess.png'
    import no_png from '../../../../assets/images/input_select.png'
    import tou from '../../../../assets/images/tou.png'
    export default {
        name: "inputSelect",
        props:{
            handleSelectInput:{
                type:Function,
                default:null
            }
        },
        data(){
            return {
                options : this.GLOBAL.options_global.people_array,
                ou_array: this.GLOBAL.options_global.territory_array,
                // parent_ou_array : this.GLOBAL.options_global.parent_ou_array,
                // ou_titie : this.GLOBAL.options_global.ou_titie,
                selectPeopleManager:this.GLOBAL.selectPeople_global,
                peopleName_global:this.GLOBAL.peopleName_global,
                parent_global:this.GLOBAL.parent_global,
                openModelSelect:false,
                suc_png:suc_png,
                no_png:no_png,
                jinyong:false,
                directly:{
                    id : '0',
                    imgSrc : no_png,
                    name:'直属团队'
                },
                allSubordinates:{
                    id : '',
                    imgSrc : no_png,
                    name:'所有下属'
                },
                self:{
                    id : this.$store.getters.getUser.user_id,
                    imgSrc : no_png,
                    name : this.$store.getters.getUser.alias,
                },
                selectObj:{
                    user_id : this.GLOBAL.selectPeople_global,
                    ou_id: this.GLOBAL.selectOu_global,
                    last_name : this.GLOBAL.peopleName_global,
                },
                data:this.GLOBAL.options_global,
                isManager:false,
                level:0
            }
        },
        created(){
            this.getManager()



        },
        updated(){
        },
        mounted(){
            this.fun_select()
        },
        methods:{
            handleSelectInputClick(j){

                console.log("j -> " + j)
                for (let i=0;i<this.options.length;i++){

                    if (j === this.options[i].id){
                        this.GLOBAL.peopleName_global =this.options[i].last_name
                    }
                }

               this.GLOBAL.selectPeople_global = j
               this.handleSelectInput(this.selectPeopleManager)

            },
            async getManager(){

                    try {

                        let data={
                            user_id : this.$store.getters.getUser.user_id,
                            tenant_id : this.$store.getters.getUser.tenant_id,
                            // isHead: 'F'
                        }
                        await http.post('/wapi/JurisdictionIn/getPersonnelByTerritoryId',data).then(res=>{
                            this.data=res.data
                            this.options = res.data.people_array
                            this.ou_array = res.data.territory_array
                            // this.ou_titie = res.data.ou_titie
                            // this.parent_ou_array = res.data.parent_ou_array
                            this.parent_global = {}
                            this.parent_global.id = res.data.territory_id
                            this.GLOBAL.parent_global = this.parent_global
                        })


                        for (let i = 0;i<this.options.length;i++){
                            this.options[i].imgSrc = no_png
                            if (this.options[i].photo_id) {
                                this.getImgUrl(this.options[i])
                            }else {
                                this.options[i].headSrc = tou
                            }

                        }
                        for (let i = 0;i<this.ou_array.length;i++){
                            this.ou_array[i].ouSrc = no_png
                        }

                        for (let j=0;j<this.options.length;){
                            if (this.options[j].id === this.$store.getters.getUser.user_id &&
                                this.options[j].id !== ''){
                                this.self = this.options[j]
                                this.options.splice(j,1)
                            }else {
                                j++
                            }
                        }
                        this.fun_select()
                        this.GLOBAL.options_global = this.data
                    } catch (e) {

                    }
            },
            clickSelectPeople(){
                if(this.jinyong==true){
                    return
                }
                this.$refs.chooseKpi.blur()
                this.fun_select()
                this.openModelSelect = true

            },
            imgClick(item){
debugger
                if (item.imgSrc === suc_png){
                    item.imgSrc = no_png
                    this.selectObj = {}
                } else {
                    item.imgSrc = suc_png
                    this.selectObj = {
                        user_id:item.id,
                        last_name:item.name,
                        territory_id:item.territory_id
                    }
                }

                for (let i=0;i<this.options.length;i++){
                    if (item.id === this.options[i].id){

                    } else {
                        this.options[i].imgSrc = no_png
                    }
                }
                for (let i=0;i<this.ou_array.length;i++){
                    this.ou_array[i].ouSrc = no_png
                }
                if (item.id === this.self.id){
                    this.allSubordinates.imgSrc = no_png
                    this.directly.imgSrc = no_png
                }else if (item.id === this.allSubordinates.id){
                    this.self.imgSrc = no_png
                    this.directly.imgSrc = no_png
                }else if (item.id === this.directly.id){
                    this.allSubordinates.imgSrc = no_png
                    this.self.imgSrc = no_png
                }else {
                    this.self.imgSrc = no_png
                    this.directly.imgSrc = no_png
                    this.allSubordinates.imgSrc = no_png
                }

                this.$forceUpdate()
            },
            ouClick(item){
debugger

                if (item.ouSrc === suc_png){
                    item.ouSrc = no_png
                    this.selectObj = {}
                } else {
                    item.ouSrc = suc_png
                    this.selectObj = {
                        ou_id:item.id,
                        last_name:item.name
                    }
                }
                for (let i=0;i<this.ou_array.length;i++){
                    if (item.id === this.ou_array[i].id){

                    } else {
                        this.ou_array[i].ouSrc = no_png
                    }
                }
                for (let i=0;i<this.options.length;i++){
                        this.options[i].imgSrc = no_png
                }
                this.self.imgSrc = no_png
                this.directly.imgSrc = no_png
                this.allSubordinates.imgSrc = no_png
                this.$forceUpdate()
            },
            clickBtn(){
                // console.log(this.selectObj,9999)
                if(this.selectObj.territory_id){
                    this.GLOBAL.selectPeople_territoryId = this.selectObj.territory_id
                }
                this.GLOBAL.selectOu_global = ''
                this.GLOBAL.selectPeople_global = ''
                this.GLOBAL.selectPeople_global = this.selectObj.user_id
                if (this.selectObj.last_name === ''){
                    this.GLOBAL.peopleName_global = '所有下属'
                    this.peopleName_global = '所有下属'
                    this.GLOBAL.selectOu_global =''
                } else {
                    this.GLOBAL.peopleName_global = this.selectObj.last_name
                    this.peopleName_global = this.selectObj.last_name
                }

                if(this.selectObj.user_id||this.selectObj.user_id==''){
                    this.handleSelectInput(this.selectObj.user_id)
                    this.GLOBAL.selectOu_global = ''
                }else if(this.selectObj.ou_id){
                    this.GLOBAL.selectPeople_global = ''
                    this.GLOBAL.selectOu_global = this.selectObj.ou_id
                    this.GLOBAL.peopleName_global = this.selectObj.last_name
                    this.peopleName_global = this.selectObj.last_name
                    this.handleSelectInput(this.selectObj.ou_id,'bm')
                }
                if(Object.keys(this.selectObj).length===0){
                    this.$message({
                        type:"warning",
                        message:'请先勾选'
                    })
                    this.openModelSelect = true
                }else{
                    this.openModelSelect = false
                }
            },
            clickBtnReturn(){
                this.getPeopleArray(this.parent_global,'back')
            },
           async getPeopleArray(item,type){

                // if (!item.id){
                //     return false
                // }

               let loading = this.$loading({
                   lock: true,
                   text: '拼命加载中',
                   spinner: 'el-icon-loading',
                   background: 'rgba(0, 0, 0, 0.7)'
               });
                try {
                    let data = {
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        user_id : this.$store.getters.getUser.user_id,
                        territory_id : item.id,
                        // ou_id : item.ou_id,
                        // isHead: 'F'
                    }
                    await http.post('/wapi/JurisdictionIn/getPersonnelByTerritoryId',data).then(res=>{
                        if (res.success === true){
                            this.allSubordinates.imgSrc = no_png
                            this.directly.imgSrc = no_png
                            this.self.imgSrc = no_png
                            this.options = res.data.people_array
                            this.ou_array = res.data.territory_array
                                // this.parent_ou_array = res.data.parent_ou_array
                                // this.ou_titie = res.data.ou_titie
                                // this.GLOBAL.options_global = res.data
                            this.parent_global = {}
                            this.parent_global.id = res.data.territory_id
                            this.GLOBAL.parent_global = this.parent_global

                            for (let i = 0;i<this.options.length;i++){
                                this.options[i].imgSrc = no_png
                                if (this.options[i].photo_id) {
                                    this.getImgUrl(this.options[i])
                                }else {
                                    this.options[i].headSrc = tou
                                }
                            }
                            for (let i = 0;i<this.ou_array.length;i++){
                                this.ou_array[i].ouSrc = no_png
                            }
                            for (let j=0;j<this.options.length;){
                                if (this.options[j].id === this.$store.getters.getUser.user_id &&
                                    this.options[j].id !== ''){
                                    this.self = this.options[j]
                                    this.options.splice(j,1)
                                }else {
                                    j++
                                }
                            }
                            if(type){
                                this.level-=1
                            }else{
                                this.level+=1
                            }
                            loading.close()
                            this.fun_select()
                            // this.isManager = false
                            // for (let k = 0;k<this.ou_titie.length;k++){
                            //     if (this.ou_titie[k].ou_id !== this.self.ou_id) {
                            //         this.isManager = true
                            //     }
                            // }
                        }
                    }).catch(err=>{
                        loading.close()
                    })
                }catch (e) {

                }
            },
           async closeModel(){
               // this.getManager()
               // this.selectObj = {
               //         user_id : '',
               //         last_name:'所有下属'
               //     }
               // this.isManager = false
               // this.allSubordinates.imgSrc = no_png
               // this.directly.imgSrc = no_png
               // this.self.imgSrc = no_png
               // console.log(this.selectObj)
               // this.selectPeopleManager
               // this.peopleName_global
            },
            fun_select(){
                let i = this.GLOBAL.selectPeople_global
                let o = this.GLOBAL.selectOu_global
                if (i === this.self.id) {
                    this.self.imgSrc = suc_png
                } else if (i === this.allSubordinates.id){
                    this.allSubordinates.imgSrc = suc_png
                } else if (i === this.directly.id){
                    this.directly.imgSrc = suc_png
                } else{
                    for (let j=0;j<this.options.length;j++){
                        if ( i === this.options[j].id){
                            this.options[j].imgSrc = suc_png
                        }
                    }
                }
                if(o){
                    for (let j=0;j<this.ou_array.length;j++){
                        if ( o === this.ou_array[j].id){
                            this.ou_array[j].ouSrc = suc_png
                        }
                    }
                }
            },
            async getImgUrl(obj) {
                try {
                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4',
                        photo_ids: obj.photo_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    let res = await http.post('/photos/downloadphotos', data)
                    let array = res.data


                    if (array.length > 0) {
                        obj.headSrc = array[0].thu_url
                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            parent_globalIsNull(){
                // if ((this.parent_global && this.parent_global.ou_id) && this.isManager){
                if (this.level>0){
                    return true
                } else {
                    return false
                }
            },
        }
    }
</script>

<style scoped>

</style>
<style>
    #selectPeople_ID .el-dialog__body{
        padding:0 0 10px 0;
        background: #f5f7fa;
    }
    #selectPeople_ID .el-dialog__header{
        padding: 0px 20px 0px !important;
    }
    #selectPeople_ID{

        text-align: left !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/calendar/components/components/inputSelect.vue